import React from "react"
import { Link } from "gatsby"

import { slugify } from "utils"

import GeneralCard from "../base"
import { BylineAuthor, BylineReviewed } from "../base/styles"
import { ArticleCategory, PartnerSponsor } from "./styles"

const ArticleCard = ({
  partnerName,
  partnerUrl,
  partnershipType,
  category,
  categoryColor,
  author,
  authorUrl,
  reviewedBy,
  reviewerUrl,
  bylineColor,
  hideOnPageLoad,
  isRailItem,
  ...props
}) => (
  <GeneralCard
    isRailItem={isRailItem}
    hideOnPageLoad={hideOnPageLoad}
    {...props}
    topLeftElement={
      <ArticleTopLeft
        category={category}
        categoryColor={categoryColor}
        partnerName={partnerName}
        partnerUrl={partnerUrl}
        partnershipType={partnershipType}
      />
    }
    bylineElement={
      <ArticleByline
        author={author}
        authorUrl={authorUrl}
        reviewedBy={reviewedBy}
        reviewerUrl={reviewerUrl}
        bylineColor={bylineColor}
      />
    }
  />
)

export const ArticleTopLeft = ({
  category,
  categoryColor,
  partnerName,
  partnerUrl,
  partnershipType,
}) => {
  if (partnerName) {
    const sponsorshipType = partnershipType === "Sponsor" ? "Sponsor | " : "Paid Content | "
    const partnerSponsor = (
      <PartnerSponsor>
        <ArticleCategory categoryColor={categoryColor}>
          {sponsorshipType} {partnerName}
        </ArticleCategory>
      </PartnerSponsor>
    )

    return partnerUrl ? (
      <Link to={partnerUrl} title={partnerName} tabIndex={-1}>
        {partnerSponsor}
      </Link>
    ) : (
      partnerSponsor
    )
  }

  const articleCategory = (
    <ArticleCategory categoryColor={categoryColor}>{category}</ArticleCategory>
  )
  return category ? (
    <Link to={`/${slugify(category)}`} title={category} tabIndex={-1}>
      {articleCategory}
    </Link>
  ) : (
    articleCategory
  )
}

export const ArticleByline = ({ author, authorUrl, reviewedBy, reviewerUrl, bylineColor }) => (
  <>
    {author &&
      (authorUrl ? (
        <Link to={authorUrl} title={author} tabIndex={-1}>
          <BylineAuthor bylineColor={bylineColor}>{author}</BylineAuthor>
        </Link>
      ) : (
        <BylineAuthor bylineColor={bylineColor}>{author}</BylineAuthor>
      ))}
    {reviewedBy &&
      (reviewerUrl ? (
        <Link to={reviewerUrl} title={reviewedBy} tabIndex={-1}>
          <BylineReviewed bylineColor={bylineColor}>Reviewed by {reviewedBy}</BylineReviewed>
        </Link>
      ) : (
        <BylineReviewed bylineColor={bylineColor}>Reviewed by {reviewedBy}</BylineReviewed>
      ))}
  </>
)

export default ArticleCard
